export const LANGUAGES = [
  { value: "sq", label: "Albanian" },
  { value: "en", label: "English" },
  { value: "de", label: "German" },
  { value: "it", label: "Italian" },
];

export const COUNTRIES = [
  { value: "AL", label: "Albania" },
  { value: "XK", label: "Kosovo" },
  { value: "DE", label: "Germany" },
  { value: "IT", label: "Italy" },
  { value: "US", label: "United States" },
  { value: "CH", label: "Switzerland" },
];

export const TIMEZONES = [
  "Europe/Tirane",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Rome",
  "America/New_York",
];

export const CALL_STATUSES = [
  "queued", "dialing", "ringing", "active", "completed", "no_answer", "busy", "voicemail",
  "failed", "cancelled",
];

export const CALL_OUTCOMES = [
  "highly_interested", "interested", "maybe", "callback_requested", "information_requested",
  "not_interested", "do_not_call", "wrong_person", "wrong_number", "voicemail", "unclassified",
];

export const CAMPAIGN_STATUSES = [
  "draft", "scheduled", "running", "paused", "completed", "stopped", "failed", "archived",
];

export const LEAD_STATUSES = [
  "new", "hot", "warm", "callback_requested", "assigned", "contacted", "converted", "lost",
];

export const CALLBACK_STATUSES = ["pending", "due", "calling", "completed", "rescheduled", "cancelled", "missed"];

export const title = (value) =>
  (value || "")
    .toString()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

export const money = (value) =>
  `$${Number(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const pct = (value) => `${Number(value || 0).toFixed(1)}%`;

export const duration = (seconds) => {
  const s = Math.max(0, Math.round(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
};

export const dt = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
};

export const dateOnly = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const relative = (value) => {
  if (!value) return "—";
  const diff = (Date.now() - new Date(value).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

const GREEN = "bg-emerald-50 text-emerald-700 ring-emerald-200";
const BLUE = "bg-blue-50 text-blue-700 ring-blue-200";
const AMBER = "bg-amber-50 text-amber-700 ring-amber-200";
const RED = "bg-rose-50 text-rose-700 ring-rose-200";
const SLATE = "bg-slate-100 text-slate-600 ring-slate-200";

export const toneFor = (value) => {
  const map = {
    running: GREEN, completed: GREEN, active: GREEN, converted: GREEN, good: GREEN,
    interested: GREEN, highly_interested: GREEN, given: GREEN, published: GREEN, available: GREEN,
    scheduled: BLUE, queued: BLUE, dialing: BLUE, ringing: BLUE, new: BLUE, assigned: BLUE,
    contacted: BLUE, information_requested: BLUE, reviewed: BLUE, pending: BLUE, due: AMBER,
    paused: AMBER, maybe: AMBER, warm: AMBER, callback_requested: AMBER, voicemail: AMBER,
    no_answer: AMBER, busy: AMBER, rescheduled: AMBER, needs_improvement: AMBER, draft: SLATE,
    hot: RED, failed: RED, stopped: RED, do_not_call: RED, not_interested: RED, lost: RED,
    missed: RED, bad: RED, compliance_issue: RED, wrong_outcome: RED,
  };
  return map[value] || SLATE;
};

export const scoreTone = (score) => {
  const n = Number(score);
  if (Number.isNaN(n)) return SLATE;
  if (n >= 8) return GREEN;
  if (n >= 5) return AMBER;
  return SLATE;
};
